<template>
  <div class="main-right">
    <div class="header">指数构成</div>
    <div class="block-body">
      <div class="body-top">
        <a-row :gutter="20">
          <a-col :span="11">
            <span class="title">{{title}}发展指标权重</span>
            <div class="pie" ref="pie1"></div>
          </a-col>
          <a-col :span="13">
            <span class="title">{{title}}发展指数经济——{{viceName}}</span>
            <div class="pie" ref="pie2"></div>
          </a-col>
        </a-row>
      </div>
      <div class="body-bottom">
        <p class="body-title">{{title}}发展指数指标</p>
        <!-- <a-table :columns="columns" :data-source="data" :pagination="false">
        </a-table> -->
        <div style="height:860px">
          <vue-scroll :ops="ops" style="height:100%">
            <table class="table">
              <tr v-for="item,key in tabData" :key="key">
                <td v-for="i ,k in item" :key="k" :class="{'tab-weight':key == 0}" @click="changeSortIcon(key,k)"> 
                  {{ i.val }} 
                  <span v-if="key==0&&k==sortIconKey" @click="sortTabData" style="cursor: pointer;">
                    <a-icon v-show="downOrup" type="caret-up" />
                    <a-icon v-show="!downOrup" type="caret-down" />
                  </span>
                </td>
              </tr>
            </table>
          </vue-scroll>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import * as echarts from "echarts";
import config from "@/until/configs"
import _ from "lodash"
const data = [
  {
    key: "1",
    city: "北京",
    fz: "0.1223",
    jj: "0.1234",
    sh: "0.12324",
    hj: "0.1234",
    gn: "0.1234",
    cx: "0.1234",
  },
  {
    key: "2",
    city: "上海",
    fz: "0.2223",
    jj: "0.1234",
    sh: "0.12324",
    hj: "0.1234",
    gn: "0.1234",
    cx: "0.1234",
  },
  {
    key: "3",
    city: "广东",
    fz: "0.3223",
    jj: "0.1234",
    sh: "0.12324",
    hj: "0.1234",
    gn: "0.1234",
    cx: "0.1234",
  },
];
const columns = [
  {
    title: "序号",
    dataIndex: "key",
    key: "key",
    width: 80,
  },
  {
    title: "城市",
    dataIndex: "city",
    key: "city",
    width: 80,
  },
  {
    title: "包容性发展指数",
    dataIndex: "fz",
    key: "fz",
    align: "center",
    sorter: (a, b) => a.fz - b.fz,
  },
  {
    title: "经济集约",
    dataIndex: "jj",
    key: "jj",
  },
  {
    title: "社会和谐",
    dataIndex: "sh",
    key: "sh",
  },
  {
    title: "环境友好",
    dataIndex: "hj",
    key: "hj",
  },
  {
    title: "功能优化",
    dataIndex: "gn",
    key: "gn",
  },
  {
    title: "城乡统筹",
    dataIndex: "cx",
    key: "cx",
  },
];
const option = {
        color:['#5c8ff9','#59d8a6','#5d7193','#f2c20b','#e7684a','#6cc9eb'],
        tooltip: {
          trigger: "item",
          formatter:'{b}<br /> {d}%',
          borderColor:'transparent',
          borderWidth:0,
          shadowBlur:0
        },
        
        legend: {
          show:true,
          bottom: '4%',
          icon:'circle',
          type:'scroll'
        },
        series: [
          {
            type: "pie",
            radius: ["55%", "80%"],
            avoidLabelOverlap: true,
            labelLine: {
              show: false,
            },
            lable:{
              width:120,
              overflow:'break',
            },
            bottom:'10%',
            data: [],
          },
        ],
  }
let pieDom1, pieDom2;
export default {
  props: ["cubeId", "year",'title'],
  data() {
    return {
      columns,
      data,
      tabData:[],
      ops:config.vueScrollSetting,
      sortIconKey:2,
      downOrup:true,
      viceName:''
    };
  },

  mounted() {
    // const dom = this.$refs.pie1
    pieDom1 = echarts.init(this.$refs.pie1);
    pieDom2 = echarts.init(this.$refs.pie2);

    // pieDom1.setOption(this.option)
    // pieDom2.setOption(this.option)
    this.getIndicatorInclude();
  },

  methods: {
    changeSortIcon(key,k){
      if(key != 0){ return }
      this.sortIconKey = k
      
    },
    sortTabData(){
      if(this.downOrup){
       this.tabData.sort((a,b)=> a[this.sortIconKey].val - b[this.sortIconKey].val)
       this.downOrup = false
      }else{
        this.tabData.sort((a,b)=>b[this.sortIconKey].val - a[this.sortIconKey].val  )
        this.downOrup = true
      }
    },
    getIndicatorInclude() {
      let params = {
        cubeId: this.cubeId,
        years: this.year,
      };
      this.$http.getIndicatorInclude(params).then((res) => {
        if(res.success){
          this.viceName = res.indicatorPie[0].indicator_name_zh;
          const indicatorPie = res.indicatorPie.map((item,key)=>{
            return {
              value : item.val,
              name : item.indicator_name_zh,
              code:item.parent_id,
              selected:key===0?true:false
            }
          })
          const indicatorRing = res.indicatorRing.map(item=>{
            return {
              value : item.val,
              name : item.indicator_name_zh

            }
          })

          const option1 = _.cloneDeep(option)
          const option2 = _.cloneDeep(option)
          option1.series[0].selectedMode = true;
          option1.series[0].data = indicatorPie
          option1.series[0].radius = ['80%']
          pieDom1.setOption(option1)

          pieDom1.on('click',e=>{
            this.viceName = e.data.name;
            indicatorPie.forEach(item=>{
              if(item.name===e.data.name) {
                item.selected = true;
              } else {
                item.selected = false;
              }
            });
            option1.series[0].data = indicatorPie
            pieDom1.setOption(option1);

            this.$http.getIndicatorInclude({...params,indicatorCode:e.data.code}).then(res=>{
              let indicatorRing = res.indicatorRing.map(item=>{
                return {
                  value : item.val,
                  name : item.indicator_name_zh

                }
              })
              option2.series[0].data = indicatorRing;
              pieDom2.setOption(option2)
            })
          })

          option2.series[0].data = indicatorRing
          option2.legend.show = false
          option2.series[0].bottom = 1
          pieDom2.setOption(option2)

          this.tabData = res.regionAllIndicatorData
        }
      });
    },
  },
  watch: {
    cubeId() {
      pieDom1.clear()
      this.getIndicatorInclude()
    },
    year() {
      pieDom1.clear()
      this.getIndicatorInclude()
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/scss/dataIndex/index.scss";
table {
  width: 100%;
  text-align: center;
  border-spacing: 0;
  border-collapse: unset;
  // border-top: 1px solid #000;
  // border-right: 1px solid #000;
  // border-collapse: collapse;
  th,
  td {
    // border-left: 1px solid #000;
    border-bottom: 1px solid #E8E8E8;
  }
  td {
    // border:1px solid #fff;
    height: 54px;
    color: #000;
    padding: 3px 5px;
    font-size: 14px;
  }
  .alignCenter {
    text-align: center;
  }
  .tab-weight{
    font-weight: 600;
    background:#FAFAFA;
  }
}
</style>
